import React from 'react';
import logoNegative from '../assets/img/logo_negativo.png';

import { Container, Row, Col} from 'reactstrap';

import {RoundButtonPrimary} from "./buttons";

import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/App.css';


const TextClaim = () => {
    return (
        <p className="text-claim mb-5" id="text_claim" style={{fontWeight: 700, fontSize: '1.5rem'}}> 
            Da { ` ${parseInt((new Date()).getFullYear()) - 2011} ` } 
            anni a supporto degli atleti e delle persone 
        </p>
    );
};


const Home = () => {
    return (
        <section className='elem-home-container d-flex'>
            <Container className='my-auto'>
                <Row>
                    <Col lg="10" className='mx-auto'>
                        <img src={logoNegative} width='100%' alt='Verbana Fisio' />
                    </Col>
                    <Col lg="8" className='mx-auto'>
                        <TextClaim />
                        <RoundButtonPrimary text='Scopri come posso aiutarti' to='/specialization' />
                    </Col>
                </Row>
            </Container>
        </section>
    );
};


export default Home;
